

export default {
  locale: 'km',
  Pagination: {
    items_per_page: '/ ទំព័រ',
    jump_to: 'លោត​ទៅ',
    jump_to_confirm: 'បញ្ជាក់',
    page: 'ទំព័រ',
    prev_page: 'ទំព័រ​មុន',
    next_page: 'ទំព័រ​​បន្ទាប់',
    prev_5: '៥ ទំព័រថយក្រោយ',
    next_5: '៥ ទំព័រទៅមុខ',
    prev_3: '៣ ទំព័រថយក្រោយ',
    next_3: '៣ ទំព័រទៅមុខ',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'រើសថ្ងៃ',
      yearPlaceholder: 'រើសឆ្នាំ',
      quarterPlaceholder: 'រើសត្រីមាស',
      monthPlaceholder: 'រើសខែ',
      weekPlaceholder: 'រើសសប្តាហ៍',
      rangePlaceholder: ['ថ្ងៃចាប់ផ្ដើម', 'ថ្ងៃបញ្ចប់'],
      rangeYearPlaceholder: ['ឆ្នាំចាប់ផ្ដើម', 'ឆ្នាំបញ្ចប់'],
      rangeMonthPlaceholder: ['ខែចាប់ផ្ដើម', 'ខែបញ្ចប់'],
      rangeWeekPlaceholder: ['សប្ដាហ៍ចាប់ផ្ដើម', 'សប្ដាហ៍បញ្ចប់'],
      locale: 'km',
      today: 'ថ្ងៃនេះ',
      now: 'ឥឡូវ​នេះ',
      backToToday: 'ត្រលប់ទៅថ្ងៃនេះ',
      ok: 'កំណត់',
      timeSelect: 'រយៈពេលជ្រើសរើស',
      dateSelect: 'ជ្រើសរើសកាលបរិច្ឆេទ',
      weekSelect: 'ជ្រើសរើសសប្តាហ៍',
      clear: 'ច្បាស់',
      month: 'ខែ',
      year: 'ឆ្នាំ',
      previousMonth: 'ខែមុន (ឡើងទំព័រ)',
      nextMonth: 'ខែបន្ទាប់ (ប៊ូតុងចុះទំព័រ)',
      monthSelect: 'ជ្រើសរើសខែ',
      yearSelect: 'ជ្រើសរើសឆ្នាំ',
      decadeSelect: 'ជ្រើសរើសអាយុ',
      yearFormat: 'YYYY',
      dayFormat: 'D',
      dateFormat: 'YYYY-M-D',
      dateTimeFormat: 'YYYY-M-D HH:mm:ss',
      previousYear: 'ឆ្នាំមុន (Controlគ្រាប់ចុចបូកព្រួញខាងឆ្វេង)',
      nextYear: 'ឆ្នាំក្រោយ (Control គ្រាប់ចុចបូកព្រួញស្ដាំ)',
      previousDecade: 'ជំនាន់ចុងក្រោយ',
      nextDecade: 'ជំនាន់​ក្រោយ',
      previousCentury: 'សតវត្សចុងក្រោយ',
      nextCentury: 'សតវត្សរ៍បន្ទាប់',
      monthBeforeYear: true
    },
    timePickerLocale: {
      placeholder: 'រើសម៉ោង',
      rangePlaceholder: ['ម៉ោងចប់ផ្ដើម', 'ម៉ោងបញ្ចប់']
    }
  },
  TimePicker: {
    placeholder: 'រើសម៉ោង',
    rangePlaceholder: ['ម៉ោងចប់ផ្ដើម', 'ម៉ោងបញ្ចប់']
  },
  Calendar: {
    lang: {
      placeholder: 'រើសថ្ងៃ',
      yearPlaceholder: 'រើសឆ្នាំ',
      quarterPlaceholder: 'រើសត្រីមាស',
      monthPlaceholder: 'រើសខែ',
      weekPlaceholder: 'រើសសប្តាហ៍',
      rangePlaceholder: ['ថ្ងៃចាប់ផ្ដើម', 'ថ្ងៃបញ្ចប់'],
      rangeYearPlaceholder: ['ឆ្នាំចាប់ផ្ដើម', 'ឆ្នាំបញ្ចប់'],
      rangeMonthPlaceholder: ['ខែចាប់ផ្ដើម', 'ខែបញ្ចប់'],
      rangeWeekPlaceholder: ['សប្ដាហ៍ចាប់ផ្ដើម', 'សប្ដាហ៍បញ្ចប់'],
      locale: 'km',
      today: 'ថ្ងៃនេះ',
      now: 'ឥឡូវ​នេះ',
      backToToday: 'ត្រលប់ទៅថ្ងៃនេះ',
      ok: 'កំណត់',
      timeSelect: 'រយៈពេលជ្រើសរើស',
      dateSelect: 'ជ្រើសរើសកាលបរិច្ឆេទ',
      weekSelect: 'ជ្រើសរើសសប្តាហ៍',
      clear: 'ច្បាស់',
      month: 'ខែ',
      year: 'ឆ្នាំ',
      previousMonth: 'ខែមុន (ឡើងទំព័រ)',
      nextMonth: 'ខែបន្ទាប់ (ប៊ូតុងចុះទំព័រ)',
      monthSelect: 'ជ្រើសរើសខែ',
      yearSelect: 'ជ្រើសរើសឆ្នាំ',
      decadeSelect: 'ជ្រើសរើសអាយុ',
      yearFormat: 'YYYY',
      dayFormat: 'D',
      dateFormat: 'YYYY-M-D',
      dateTimeFormat: 'YYYY-M-D HH:mm:ss',
      previousYear: 'ឆ្នាំមុន (Controlគ្រាប់ចុចបូកព្រួញខាងឆ្វេង)',
      nextYear: 'ឆ្នាំក្រោយ (Control គ្រាប់ចុចបូកព្រួញស្ដាំ)',
      previousDecade: 'ជំនាន់ចុងក្រោយ',
      nextDecade: 'ជំនាន់​ក្រោយ',
      previousCentury: 'សតវត្សចុងក្រោយ',
      nextCentury: 'សតវត្សរ៍បន្ទាប់',
      monthBeforeYear: true
    },
    timePickerLocale: {
      placeholder: 'រើសម៉ោង',
      rangePlaceholder: ['ម៉ោងចប់ផ្ដើម', 'ម៉ោងបញ្ចប់']
    }
  },
  global: {
    placeholder: 'សូមជ្រើសរើស'
  },
  Table: {
    filterTitle: 'បញ្ចីតម្រៀប',
    filterConfirm: 'យល់ព្រម',
    filterReset: 'ត្រឡប់ដើម',
    filterEmptyText: 'គ្មានបញ្ចីតម្រៀប',
    emptyText: 'គ្មានទិន្នន័យ',
    selectAll: 'រើសក្នុងទំព័រនេះ',
    selectInvert: 'បញ្ច្រាសក្នុងទំព័រនេះ',
    selectNone: 'លុបចេញទាំងអស់',
    selectionAll: 'រើសយកទាំងអស់',
    sortTitle: 'តម្រៀប',
    expand: 'ពន្លាត',
    collapse: 'បិតបាំង',
    triggerDesc: 'ចុចដើម្បីរៀបតាមលំដាប់ធំ',
    triggerAsc: 'ចុចដើម្បីរៀបតាមលំដាប់តូច​',
    cancelSort: 'ចុចដើម្បីបោះបង់'
  },
  Modal: {
    okText: 'យល់ព្រម',
    cancelText: 'បោះបង់',
    justOkText: 'យល់ព្រម'
  },
  Popconfirm: {
    okText: 'យល់ព្រម',
    cancelText: 'បោះបង់'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'ស្វែងរកនៅទីនេះ',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'លុប',
    selectCurrent: 'រើសទំព័របច្ចុប្បន្ន',
    removeCurrent: 'លុបទំព័របច្ចុប្បន្ន',
    selectAll: 'រើសទិន្នន័យទាំងអស់',
    removeAll: 'លុបទិន្នន័យទាំងអស់',
    selectInvert: 'បញ្ច្រាសទំព័របច្ចុប្បន្ន'
  },
  Upload: {
    uploading: 'កំពុងបញ្ចូលឡើង...',
    removeFile: 'លុបឯកសារ',
    uploadError: 'បញ្ចូលមិនជោកជ័យ',
    previewFile: 'មើលឯកសារ',
    downloadFile: 'ទាញយកឯកសារ'
  },
  Empty: {
    description: 'គ្មានទិន្នន័យ'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'កែ',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'ពង្រីក'
  },
  PageHeader: {
    back: 'Back'
  }
};
